import styled from "styled-components";

export const NotFoundStyled = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgb(255, 255, 255, 0.2);
  backdrop-filter: blur(30px);
  display: grid;
  place-items: center;
  z-index: 400;
  padding-left: 30px;
  box-sizing: border-box;
  padding-right: 30px;
  text-align: center;
  a {
    color: inherit;
    margin-left: 5px;
  }
`;
